import React from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import { Helmet } from "react-helmet";
import { appUrl } from "../../redux/base/types/url";
import images from "../../assets/images";

const blogData = [
  {
    title: "How to Choose the Best Car Rental Software",
    slug: "freemium-car-rental-software",
    description: "Learn how to select the perfect car rental software based on your fleet size and operational goals.",
    image:images.AssetsDashboard
  
  },
  {
    title: "Maximizing Profit with Dynamic Pricing",
    slug: "dynamic-pricing-car-rental",
    description: "Explore how to optimize your rental rates using Rentificial’s smart pricing module.",
    image: "/images/pricing-dashboard.png"
  },
  {
    title: "Why You Need Reminder Modules",
    slug: "reminder-modules-car-rental",
    description: "Discover how Rentificial's smart reminder system helps reduce missed payments, late returns, and boosts customer satisfaction.",
    image: "/images/reminder-dashboard.png"
  },
  // Diğer 7 blog için aynı formatta obje eklenebilir
];

const Blogsindex = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Car Rental Software Blogs | Rentificial</title>
        <meta
          name="description"
          content="Read expert-written blog posts on car rental software, fleet management tips, and Rentificial feature guides."
        />
        <meta name="keywords" content="car rental software blogs, fleet management, Rentificial, how to choose software" />
        <meta property="og:title" content="Car Rental Software Blogs | Rentificial" />
        <meta property="og:description" content="Insights and guides on choosing and using the best car rental software for your business." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.rentificial.com/blogs" />
        <meta property="og:image" content="https://www.rentificial.com/images/fleet-dashboard.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Car Rental Software Blogs | Rentificial" />
        <meta name="twitter:description" content="Explore expert blog content on Rentificial’s car rental tools and tips for your rental business." />
        <meta name="twitter:image" content="https://www.rentificial.com/images/fleet-dashboard.png" />
        <link rel="canonical" href="https://www.rentificial.com/blogs" />
        <meta name="twitter:site" content="@rentificial" />
        <meta name="twitter:creator" content="@rentificial" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Homepage", "item": "${appUrl}" },
                { "@type": "ListItem", "position": 2, "name": "Blogs", "item": "${appUrl + "/blogs"}" }
              ]
            }`}
        </script>
      </Helmet>
      <Container className="py-5">
                    <section className="blog-section py-5" style={{ backgroundColor: "#fff" }}>
                  
                  <Row className="mt-5">
                    <Col md={12} className="text-left">
          <div className="container">
          <h1 className="text-center mb-4">📝 Rentificial Blog</h1>
    </div></Col></Row>
      
         
          <Row>
            {blogData.map((blog, index) => (
              <Col md={4} sm={6} xs={12} className="mb-4" key={index}>
                <Card className="h-100 shadow-sm">
                  <img src={blog.image} className="card-img-top" alt={blog.title} style={{ maxHeight: 200, objectFit: 'cover' }} />
                  <CardBody>
                    <h5 className="font-weight-bold">{blog.title}</h5>
                    <p className="text-muted" style={{ minHeight: 60 }}>{blog.description}</p>
                    <a href={`/blogs/${blog.slug}`} className="btn btn-sm btn-outline-primary">
                      Read More →
                    </a>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
          </section>
        </Container>
    </React.Fragment>
  );
};

export default Blogsindex;
